import React, { Component } from 'react';

import './RpmDataTable.css';

import AirTable from '../../../../../../../common/components/AirTable';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

@inject('translationsStore', 'commonStore')
@observer
export default class RpmDataTable extends Component {
  render() {
    const { translationsStore, commonStore } = this.props;

    let dataSource = this.props.rpms || [];
    dataSource = dataSource.map((row, index) => ({ ...row, key: index }));

    const columns = [
      {
        dataIndex: 'startDateTime',
        align: 'center',
        width: '150px',
        title: translationsStore.translate('quickFocus.rpm.summary.table.date'),
        sorter: (a, b) => (a.startDateTime < b.startDateTime ? -1 : a.startDateTime === b.startDateTime ? 0 : 1),
        render: startDateTime => `${moment(startDateTime).format(commonStore.longDateFormat.L)} ${moment(startDateTime).format(commonStore.longDateFormat.LT)}`
      },

      {
        key: 'address',
        dataIndex: 'address',
        align: 'center',
        title: translationsStore.translate('quickFocus.rpm.summary.table.position'),
        sorter: (a, b) => (a.address < b.address ? -1 : a.address === b.address ? 0 : 1)
      },
      {
        dataIndex: 'value',
        width: '140px',
        align: 'center',
        className: 'client',
        title: translationsStore.translate('quickFocus.rpm.summary.table.rpmMaxValue'),
        sorter: (a, b) => (a.value < b.value ? -1 : a.value === b.value ? 0 : 1),
        render: rpmValue => rpmValue.toLocaleString(commonStore.momentLocale)
      },
      {
        dataIndex: 'duration',
        width: '80px',
        align: 'center',
        title: translationsStore.translate('quickFocus.rpm.summary.table.duration'),
        sorter: (a, b) => (a.duration < b.duration ? -1 : a.duration === b.duration ? 0 : 1),
        render: duration =>
          moment()
            .startOf('day')
            .seconds(duration)
            .format('H:mm:ss')
      },
      {
        dataIndex: 'distance',
        width: '80px',
        align: 'center',
        title: translationsStore.translate('quickFocus.rpm.summary.table.distance'),
        sorter: (a, b) => (a.distance < b.distance ? -1 : a.distance === b.distance ? 0 : 1),
        render: distance => `${(distance / 1000).toLocaleString(commonStore.momentLocale)} km`
      },
      {
        dataIndex: 'overRpmThreshold',
        width: '140px',
        align: 'center',
        title: translationsStore.translate('quickFocus.rpm.summary.table.overRpmThreshold'),
        sorter: (a, b) => (a.overRpmThreshold < b.overRpmThreshold ? -1 : a.overRpmThreshold === b.overRpmThreshold ? 0 : 1),
        render: value => value.toLocaleString(commonStore.momentLocale)
      }
    ];

    return (
      <div className="RpmDataTable">
        <AirTable rowKey="id" rowSelection={false} columns={columns} dataSource={dataSource} pageSize={4} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmDataTable/RpmDataTable.js